var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { html } from 'lit';
import { property } from 'lit/decorators.js';
import { ifDefined } from 'lit/directives/if-defined.js';
import { BlocksElement } from '../../BlocksElement';
import styles from '../icon.styles';
/**
 * Copy component
 * @csspart base- The component's base wrapper
 */
export class BlocksIconCopy extends BlocksElement {
    static { this.styles = styles; }
    connectedCallback() {
        super.connectedCallback();
        this.classList.add('cat-icon');
    }
    render() {
        const componentClassName = this.componentClassNames('cat-c-icon', {
            'cat-c-icon--sm': this.size === 'sm',
            'cat-c-icon--lg': this.size === 'lg',
            'cat-c-icon--xl': this.size === 'xl',
            'cat-c-icon--content-strong': this.color === 'content-strong',
            'cat-c-icon--knockout': this.color === 'knockout',
            'cat-c-icon--knockout-brand': this.color === 'knockout-brand',
            'cat-c-icon--information': this.color === 'information',
            'cat-c-icon--success': this.color === 'success',
            'cat-c-icon--warning': this.color === 'warning',
            'cat-c-icon--error': this.color === 'error'
        });
        return html `
      <span part="base" class="${componentClassName}" role="presentation">
        <svg
          aria-hidden="${!this.iconTitle}"
          aria-label="${ifDefined(this.iconTitle)}"
          role="${this.iconTitle && 'img'}"
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M3.8623 3.27354C3.8623 2.9043 4.16163 2.60498 4.53085 2.60498H13.0422C13.4564 2.60498 13.7922 2.26919 13.7922 1.85498C13.7922 1.44077 13.4564 1.10498 13.0422 1.10498H4.53085C3.33319 1.10498 2.3623 2.07588 2.3623 3.27354V16.0406C2.3623 16.4548 2.69809 16.7906 3.1123 16.7906C3.52652 16.7906 3.8623 16.4548 3.8623 16.0406V3.27354ZM16.0049 5.4751C16.0245 5.4751 16.044 5.47585 16.0633 5.47734C16.8504 5.48155 17.6048 5.79251 18.1661 6.34393L20.7144 8.56974C20.7271 8.58081 20.7394 8.59231 20.7513 8.60421C21.3186 9.17133 21.6372 9.94052 21.6372 10.7425V20.5841C21.6372 21.8603 20.6026 22.8949 19.3264 22.8949H9.12912C7.85292 22.8949 6.81836 21.8604 6.81836 20.5841V7.78806C6.81836 6.51188 7.85291 5.47729 9.12911 5.47729H15.947C15.9661 5.47584 15.9854 5.4751 16.0049 5.4751ZM9.12911 6.97729H15.2549V10.6918C15.2549 11.106 15.5907 11.4418 16.0049 11.4418H20.1372V20.5841C20.1372 21.0319 19.7742 21.3949 19.3264 21.3949H9.12912C8.68134 21.3949 8.31836 21.0319 8.31836 20.5841V7.78806C8.31836 7.34028 8.68135 6.97729 9.12911 6.97729ZM16.7549 9.94177H19.9098C19.8522 9.84849 19.7843 9.76104 19.7068 9.68121L17.1616 7.45819C17.1489 7.44709 17.1366 7.43556 17.1246 7.42362C17.0148 7.3138 16.89 7.22246 16.7549 7.15163V9.94177Z"
          />
        </svg>
      </span>
    `;
    }
}
__decorate([
    property({ type: String })
], BlocksIconCopy.prototype, "color", void 0);
__decorate([
    property({ type: String })
], BlocksIconCopy.prototype, "iconTitle", void 0);
__decorate([
    property({ type: String })
], BlocksIconCopy.prototype, "size", void 0);
if (customElements.get('cat-icon-copy') === undefined) {
    customElements.define('cat-icon-copy', BlocksIconCopy);
}
